import React, { FC, ReactElement, ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useAuth0 } from '@auth0/auth0-react';
import LoadingSpinner from './LoadingSpinner';

type AuthenticatedRouteProps = {
  children: ReactNode;
  redirectTo?: string;
};

const AuthenticatedRoute: FC<AuthenticatedRouteProps> = ({ children, redirectTo = '/' }: AuthenticatedRouteProps): ReactElement => {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default AuthenticatedRoute;
